import type { JSX } from "react";

import { healthBarWidth } from "../lib/diff-format";

interface HealthBarProps {
  pct: number | null | undefined;
  over: boolean;
}

export function HealthBar({ pct, over }: HealthBarProps): JSX.Element {
  const width = healthBarWidth(pct);
  const color = over ? "var(--intent-danger-fg)" : "var(--text-subtle)";
  return (
    <span className="inline-block h-1.5 w-[42px] rounded-full bg-[var(--surface-sunken)] align-middle">
      <span
        className="block h-full rounded-full"
        style={{ width: `${width}%`, background: color }}
      />
    </span>
  );
}
